/**
 * Egy mező SZERKESZTHETŐSÉGE a descriptorból — a négy kártyán szó szerint ismételt két sor helyett
 * (`const editable = d.editable ?? true; const readOnly = d.readOnly ?? false;`).
 *
 * A `defaultEditable` SZÁNDÉKOSAN paraméter: az Enum kártya szigorúbb az általánosnál — nála a hiányzó
 * `editable` LETILTÁST jelent (`EnumCardContent`: `editable ?? false`, és ezért a `paramDefaults`
 * `PARAM_DEFAULTS.Enum` ága is `d?.editable !== true`-t néz). Ha itt egyetlen fix alapértelmezés lenne,
 * az vagy az Enumot nyitná ki, vagy minden mást zárna be.
 */
export type TFieldAccess = {
    editable: boolean;
    readOnly: boolean;
    /** Van-e értelme "visszaállítás alapértelmezettre" gombnak: zárolt mezőn nincs. */
    resettable: boolean;
};

export const fieldAccess = (
    descriptor: { editable?: boolean; readOnly?: boolean } | undefined,
    defaultEditable = true
): TFieldAccess => {
    const editable = descriptor?.editable ?? defaultEditable;
    const readOnly = descriptor?.readOnly ?? false;

    return { editable, readOnly, resettable: editable && !readOnly };
};

export default fieldAccess;
